import axios from 'axios';
import { ENDPOINTS } from '@/settings/endpoints';
import VueCookie from 'vue-cookie';

export class PegasusPangareClient {
  private static requestClient = axios.create({
    baseURL: ENDPOINTS.pegasusPangareUrl,
  });

  static async request(requestInformation: {
    method: string;
    requestURL: string;
    params?: any;
    bodyData?: any;
  }) {
    try {
      const token = VueCookie.get('d', { domain: '.descomplica.com.br' });

      const response = await this.requestClient.request({
        method: requestInformation.method,
        url: requestInformation.requestURL,
        params: requestInformation.params,
        data: requestInformation.bodyData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return error.response ? error.response.data : error;
    }
  }
}

export default PegasusPangareClient;
